import React from "react";

export const SectionRundown = ({ rundown, eventTitle }) => {
  const staticRundown = [
    {
      activity: "Participant Registration",
      date: "2025-10-13",
      time: "07:30-08:00",
      speaker: "Committee",
    },
    {
      activity:
        "Opening: National Anthem 'Indonesia Raya', Prayer, Activity Report, Opening Remarks, Welcome Speech, Photo Session",
      date: "2025-10-13",
      time: "08:00-08:30",
      speaker:
        "MC: Novita Noor Isnaeni, Conductor: Ade Vina Mardila, Prayer: Fathuddin, Team Leader: Dr. Angga Prananda Bhakti, West Java Dispora, Assistant Deputy for Sports Cultivation and Organizations",
    },
    {
      activity: "Material 1: Introduction to Coaching Basics",
      date: "2025-10-13",
      time: "08:30-12:00",
      speaker: "Prof. Dr. Djohansayah Lubis, M.Pd.",
    },
    {
      activity: "Break & Lunch",
      date: "2025-10-13",
      time: "12:00-13:30",
      speaker: "",
    },
    {
      activity: "Material 2: Sport Nutrition",
      date: "2025-10-13",
      time: "13:30-17:30",
      speaker: "Prof. Dr. H. Sukur, S.Pd., M.Si.",
    },
    {
      activity: "Break",
      date: "2025-10-13",
      time: "17:30-18:30",
      speaker: "",
    },
    {
      activity: "Material 3: Program Development (Periodization)",
      date: "2025-10-13",
      time: "18:30-20:30",
      speaker: "Prof. Dr. Djohansayah Lubis, M.Pd.",
    },
    {
      activity: "Breakfast",
      date: "2025-10-14",
      time: "06:00-08:00",
      speaker: "",
    },
    {
      activity: "Material 4: Introduction to Trail Terrain, Navigation, and Orientation",
      date: "2025-10-14",
      time: "08:30-12:00",
      speaker: "Dian Sukmara",
    },
    {
      activity: "Break & Lunch",
      date: "2025-10-14",
      time: "12:00-13:30",
      speaker: "",
    },
    {
      activity:
        "Material 5: Performance Improvement in Running with Elevation and Management of Outdoor Sports Risk",
      date: "2025-10-14",
      time: "13:30-17:30",
      speaker: "Hendra Siswanto",
    },
    {
      activity: "Break",
      date: "2025-10-14",
      time: "17:30-18:30",
      speaker: "",
    },
    {
      activity: "Material 6: General Handling of Sports Injuries",
      date: "2025-10-14",
      time: "18:30-21:30",
      speaker: "Slamet Rujito, SST.FT., M.K.M., C-OMPT., C-DNP.",
    },
    {
      activity: "Breakfast",
      date: "2025-10-15",
      time: "05:00-06:00",
      speaker: "",
    },
    {
      activity: "Practice",
      date: "2025-10-15",
      time: "06:00-16:00",
      speaker: "Coach: Hendra Siswanto",
    },
    { activity: "Break", date: "2025-10-15", time: "16:00", speaker: "" },
    {
      activity: "Breakfast",
      date: "2025-10-16",
      time: "06:00-09:00",
      speaker: "",
    },
    {
      activity: "Post Test",
      date: "2025-10-16",
      time: "09:00-09:30",
      speaker: "Committee",
    },
    {
      activity: "Closing",
      date: "2025-10-16",
      time: "09:30-10:00",
      speaker: "Committee",
    },
  ];

  const rundownData =
    eventTitle === "Pelatihan Tenaga Olahraga Masyarakat"
      ? staticRundown
      : rundown;

  // Fungsi format tanggal: hanya tanggal + bulan
  const formatDayMonth = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDate();
    const month = date.toLocaleString("en-US", { month: "long" });
    return `${day} ${month}`;
  };

  return (
    <section className="text-cyan-900">
      <div className="overflow-x-auto">
        <table className="w-full table-auto divide-y divide-gray-200">
          <thead>
            <tr className="bg-gray-100">
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-600 uppercase tracking-wider">
                Date
              </th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-600 uppercase tracking-wider">
                Time
              </th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-600 uppercase tracking-wider">
                Activity
              </th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-600 uppercase tracking-wider">
                Speaker/Discussant
              </th>
            </tr>
          </thead>
          <tbody>
            {rundownData && rundownData.length > 0 ? (
              rundownData.map((entry, index) => (
                <tr
                  key={index}
                  className="border-b border-gray-200 hover:bg-gray-50"
                >
                  <td className="px-4 py-4 text-sm text-gray-700 whitespace-nowrap">
                    {formatDayMonth(entry.date) || "-"}
                  </td>
                  <td className="px-4 py-4 text-sm text-gray-700 whitespace-nowrap">
                    {entry.time || "-"}
                  </td>
                  <td className="px-4 py-4 text-sm text-gray-700">
                    {entry.activity || "-"}
                  </td>
                  <td className="px-4 py-4 text-sm text-gray-700">
                    {entry.speaker || "-"}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan="4"
                  className="px-4 py-4 text-sm text-gray-700 text-center"
                >
                  No rundown data available.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </section>
  );
};
